module.exports = __webpack_public_path__ + "static/media/ScaleIreland.0cb66acc.png";